
import React from 'react';
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";

import "../../../style/PriorityTableStyles/taskstable.css";
import {useLogMetric} from "../../../hooks/useLogMetric";

interface PaginationTaskTableProps {
    pageCounter: number;
    totalPageNumber: number;
    setPageCounter: (value: number) => void;
}

export const PaginationTaskTable = ({
                                        pageCounter,
                                        totalPageNumber,
                                        setPageCounter
                                    }: PaginationTaskTableProps) => {
    const logMetricHook = useLogMetric();

    const logMetric = (action: string) => {
        logMetricHook({category: "Pagination", subCategory: `${action} page`, message: `User clicked ${action} pagination`});
    };

    const handlePreviousPagination = () => {
        if (pageCounter > 1) {
            setPageCounter(pageCounter - 1);
            logMetric("Previous");
        }
    };

    const handleNextPagination = () => {
        if (pageCounter < totalPageNumber) {
            setPageCounter(pageCounter + 1);
            logMetric("Next");
        }
    };

    return (<div>
        <button
            onClick={handlePreviousPagination}
            disabled={pageCounter <= 1}
            title="Forrige side"
            className="pagination-button previous"
        >
            <ArrowBackIosNewRoundedIcon/>
        </button>
        <span className="pagination-counter">
                {totalPageNumber === 0 ? "-" : `${pageCounter}/${totalPageNumber}`}
                    </span>
        <button
            onClick={handleNextPagination}
            disabled={pageCounter === totalPageNumber || totalPageNumber === 0}
            title="Neste side"
            className="pagination-button next"
        >
            <ArrowBackIosNewRoundedIcon className="pagination-icon-flip"/>
        </button>
    </div>)
}
